import { z } from "zod";

export const AccountSchema = z
  .object({
    organizationName: z.string().min(2, {
      message: "Organization name must be at least 2 characters long"
    }),
    firstName: z.string().min(4, {
      message: "Given name must be at least 4 characters long"
    }),
    familyName: z.string().min(3, {
      message: "Family name must be at least 3 characters long"
    }),
    username: z
      .string()
      .min(3, { message: "Username must be at least 3 characters long" }),
    email: z.string().email({ message: "Invalid email address" }),
    password: z
      .string()
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).*$/, {
        message:
          "Password must contain at least one lowercase letter, one uppercase letter, and one special character"
      }),
    passwordConfirmation: z
      .string()
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).*$/, {
        message:
          "Password must contain at least one lowercase letter, one uppercase letter, and one special character"
      })
  })
  .refine(data => data.password === data.passwordConfirmation, {
    message: "Passwords don't match",
    path: ["passwordConfirmation"]
  });

const NewAccountRegisterSchema = z.object({
  token: z.string().nullable(),
  registerDto: AccountSchema
});

export type NewAccountRegisterPayload = z.infer<
  typeof NewAccountRegisterSchema
>;
export type NewAccountPayload = z.infer<typeof AccountSchema>;
